import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsJaguarComponent } from './simple-icons-jaguar.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsJaguarComponent ],
    exports:      [ SimpleIconsJaguarComponent ],
    bootstrap:    []
})
export class SimpleIconsJaguarModule {}
